import '../SideMenu.scss';

import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { DefaultRoutes } from 'Routes';
import { observer } from 'mobx-react-lite';

const adminSubmenuData = [
  {
    label: 'Modules',
    route: DefaultRoutes.ModuleList,
  },
  {
    label: 'Trackman Parameters',
    route: DefaultRoutes.TrackmanParametersList,
  },
  {
    label: 'User',
    route: DefaultRoutes.User,
  },
  { label: 'Translation', route: DefaultRoutes.Translation },
  {
    label: 'Organization List',
    route: DefaultRoutes.OrganizationsList,
  },
  {
    label: 'Test Invitations',
    route: DefaultRoutes.TestInvitations,
  },
  {
    label: 'Partners List',
    route: DefaultRoutes.PartnersList,
  },
  {
    label: 'Masters List',
    route: DefaultRoutes.MastersList,
  },
  {
    label: 'Tour Averages',
    route: DefaultRoutes.TourAverages,
  },
  {
    label: 'Events List',
    route: DefaultRoutes.EventsList,
  },
];

export const AdminSubmenu = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isActive, setIsActive] = useState('');

  useEffect(() => {
    setIsActive(location.pathname);
  }, [location.pathname]);

  return (
    <ul className='admin-submenu-container'>
      {adminSubmenuData.map((item, index) => (
        <li
          key={index}
          className={`menu-item submenu-item ${isActive.includes(DefaultRoutes.Admin + '/' + item.route) ? 'active' : ''}`}
          onClick={() => navigate(DefaultRoutes.Admin + '/' + item.route)}
        >
          {item.label}
        </li>
      ))}
    </ul>
  );
});

export default AdminSubmenu;
